import { ESubProductIds } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import { useSelector } from "react-redux";
export var useBookMarkStateData = function (subCategoryId) {
    var _a = useSelector(function (state) { return state.markets.Otc.productBouquetReducer; }), bookMarkListSp = _a.bookMarkListSp, bookMarkListNcd = _a.bookMarkListNcd, bookMarkListBonds = _a.bookMarkListBonds, bookMarkListUnlistedShares = _a.bookMarkListUnlistedShares;
    switch (String(subCategoryId)) {
        case ESubProductIds.NCD:
            return bookMarkListNcd;
        case ESubProductIds.StructuredProducts:
            return bookMarkListSp;
        case ESubProductIds.Bonds:
            return bookMarkListBonds;
        case ESubProductIds.UnlistedShares:
            return bookMarkListUnlistedShares;
    }
};
